import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { type FC } from "react";
import { type MomentExistingFollowUps } from "../../../../follow-up/server/follow-up-service";
import type { FollowUpMomentDetails } from "../../../../follow-up/server/types";
import { FollowUpMomentsTable } from "../../follow-up/follow-up-moments-table";
import { useFollowUpMomentDetails } from "../../follow-up/hooks/use-follow-up-moment-details";

export const ShowFollowUpMomentsDialog: FC<{
  open: boolean;
  onClose(): void;
  data: MomentExistingFollowUps;
  onCreateFollowUp(followUpData: FollowUpMomentDetails): void;
}> = ({ open, onClose, data, onCreateFollowUp }) => {
  const loader = useFollowUpMomentDetails(data.id);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Follow-Ups for this Communication</DialogTitle>
      <DialogContent>
        <FollowUpMomentsTable followUpDataLoader={loader} onCreateFollowUp={onCreateFollowUp} />
      </DialogContent>
      <DialogActions>
        <Button
          data-analytics-id="moment-form-follow-up-dialog-close-button"
          variant="text"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
